import { render, staticRenderFns } from "./SignupPackagesTiers.vue?vue&type=template&id=80000b42"
import script from "./SignupPackagesTiers.vue?vue&type=script&lang=js"
export * from "./SignupPackagesTiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports